import { z } from 'zod'
import { KaskoDocument } from '~/shared/api'
import { Option } from '~/shared/config/constants'
import { priceRequiredScheme } from '~/shared/lib/schemas'

const baseSchema = KaskoDocument.schema.pick({
  series: true,
  number: true,
  issuedDate: true,
  expirationDate: true,
  counterpartyId: true,
})

export const formSchema = baseSchema.and(
  z.object({ premium: priceRequiredScheme }),
)

export type TypeFormSchema = z.infer<typeof formSchema>

export type FormValues = Omit<TypeFormSchema, 'counterpartyId'> & {
  counterpartyId: UniqueId | Option | null
}
